import type { CellRendererContext } from "echart-table-library";

/**
 * Business callback for the imported config's pinned `select` column:
 * a checkbox reflecting the row's live selection state (provided by the
 * library's cell-renderer context). Toggling happens via the row click
 * handler, so the input stays presentational.
 */
export function renderSelectCheckbox({
  selected,
}: CellRendererContext): HTMLElement {
  const input = document.createElement("input");
  input.type = "checkbox";
  input.checked = selected ?? false;
  input.className = "h-4 w-4 cursor-pointer accent-[hsl(var(--primary))]";
  input.setAttribute("aria-label", "Select row");
  return input;
}
